import { VhcItem } from 'features/vhc/model';
import { useVhcStore } from 'features/vhc/model/vhc-store';
import { Controller, useFormContext } from 'react-hook-form';
import Select from 'react-select';

export const BrakeConditionSelect = () => {
  const { control, formState } = useFormContext<VhcItem>();
  const { recordModalData } = useVhcStore();
  const { isReport, isComplete } = recordModalData || {};

  const options = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' }
  ];

  const getStyle = (val?: number | null) => {
    if (val == null) return { backgroundColor: '#F5F8FA', color: 'black' };
    if (val == 1) return { backgroundColor: '#dc3545', color: 'white' };
    if (val == 2) return { backgroundColor: '#ffc107', color: 'black' };
    if (val == 3) return { backgroundColor: '#28a745', color: 'white' };
    return { backgroundColor: '#F5F8FA', color: 'black' };
  };

  return (
    <Controller
      name="brakeCondition"
      control={control}
      render={({ field }) => {
        const selectedOption = options.find((o) => o.value === field.value);
        const style = getStyle(selectedOption?.value);

        return (
          <Select
            {...field}
            value={options.find((o) => o.value === field.value) ?? null}
            onChange={(option) => field.onChange(option?.value ?? null)}
            options={options}
            isDisabled={isReport || isComplete}
            isSearchable={false}
            placeholder=" "
            styles={{
              control: (base) => ({
                ...base,
                backgroundColor: style.backgroundColor,
                color: style.color,
                borderColor: formState.errors['brakeCondition'] ? 'is-invalid' : '#ccc',
                boxShadow: 'none',
                minHeight: 36,
                width: 100,
                '&:hover': { borderColor: '#aaa' }
              }),
              singleValue: (base) => ({
                ...base,
                color: style.color
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isFocused ? '#f1f1f1' : '#fff',
                color: '#000',
                cursor: 'pointer'
              }),
              menu: (base) => ({
                ...base,
                zIndex: 100
              })
            }}
          />
        );
      }}
    />
  );
};
